import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import { FormattedMessage } from 'react-intl';
import Form from './form';

const View = ({ handleRegister, handleCancel, playerSettings }) => (
  <Card className="profile">
    <CardContent>
      <Typography variant="h5" component="h2" className="profile-title-text">
        <FormattedMessage id="profile.title" />
      </Typography>
      <div className="profile-input-block">
        <Form
          handleRegister={handleRegister}
          handleCancel={handleCancel}
          playerSettings={playerSettings}
        />
      </div>
    </CardContent>
  </Card>
);

View.propTypes = {
  handleRegister: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  playerSettings: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
